/* tslint:disable */
/* eslint-disable */
/**
 * 3DSurvey API
 * Frontend API for 3d Survey
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExternalImageMetadataPoseRotation
 */
export interface ExternalImageMetadataPoseRotation {
    /**
     * 
     * @type {number}
     * @memberof ExternalImageMetadataPoseRotation
     */
    x: number;
    /**
     * 
     * @type {number}
     * @memberof ExternalImageMetadataPoseRotation
     */
    y: number;
    /**
     * 
     * @type {number}
     * @memberof ExternalImageMetadataPoseRotation
     */
    z: number;
    /**
     * 
     * @type {number}
     * @memberof ExternalImageMetadataPoseRotation
     */
    w: number;
}

/**
 * Check if a given object implements the ExternalImageMetadataPoseRotation interface.
 */
export function instanceOfExternalImageMetadataPoseRotation(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "x" in value;
    isInstance = isInstance && "y" in value;
    isInstance = isInstance && "z" in value;
    isInstance = isInstance && "w" in value;

    return isInstance;
}

export function ExternalImageMetadataPoseRotationFromJSON(json: any): ExternalImageMetadataPoseRotation {
    return ExternalImageMetadataPoseRotationFromJSONTyped(json, false);
}

export function ExternalImageMetadataPoseRotationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExternalImageMetadataPoseRotation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'x': json['x'],
        'y': json['y'],
        'z': json['z'],
        'w': json['w'],
    };
}

export function ExternalImageMetadataPoseRotationToJSON(value?: ExternalImageMetadataPoseRotation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'x': value.x,
        'y': value.y,
        'z': value.z,
        'w': value.w,
    };
}

